<template>
  <div class="px-3">
    <div class="d-flex justify-content-between px-5">
      <div></div>
      <h5 class="py-3">{{isLesson ? $t('select_topic') : '請從下方選擇分類'}}</h5>
      <img class="back-icon pointer my-4" @click="previousPage" style="height:20px" src="../../../assets/image/icon/close_lesson.png" />
    </div>
    <div class="my-5 list-box">
      <div v-for="(item ,index) in resourceOptions" @click="goDownloadPage(item.category)" :key="index" class="menu-box">
        <p>{{item.name}}</p>
        <p>{{item.title}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../store/api'
import Pagination from '../../../components/Pagination'

export default {

  name: 'ARDownload',
  components: {
    Pagination
  },
  data () {
    return {
      isdownload: false,
      isLesson: false,
      lessonList: [],
      currentPage: 1,
      pageSize: 12,
      resourceOptions: [
        {
          name: '教學簡報',
          title: 'Teaching PPT',
          category: 'ppt'
        },
        {
          name: 'AR辨識閃卡',
          title: 'AR Flashcards',
          category: 'flashcard'
        },
        {
          name: '示範教案（含課程大綱）',
          title: 'Sample Teaching Plans (Syllabus included)',
          category: 'plan'
        },
        {
          name: 'It`s A Big World 相關',
          title: 'It`s A Big World Files',
          category: 'review'
        }
      ]
    }
  },

  computed: {
  },
  mounted () {
    this.getLesson()
  },

  methods: {
    goPage (page) {
      this.currentPage = page
      this.getLesson()
    },
    async getLesson () {
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize
      }
      const { data } = await api.get(`/Globetrotting/Country/${this.$route.params.id}/Lesson`, { params })
      if (data.status === 'OK') {
        this.lessonList = data
      }
    },
    goDownloadPage (category) {
      this.isdownload = true
      this.$router.push({name: 'ar_resource', params: {id: this.$route.params.id, category: category}})
    },
    previousPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .list-box {
    width: 60%;
    margin: auto;
  }
  .menu-box {
    cursor: pointer;
    text-align: left;
    background-color: #fff;
    border-radius: 10px;
    border: 1.5px solid #6666;
    margin: 20px auto;
    padding: 10px 20px;
    p {
      margin: 0;
    }
      &:hover {
      box-shadow:0px 0px 8px #a1a1a1;
    }
  }
</style>



// WEBPACK FOOTER //
// Download.vue?5af54c49